<template>
  <v-container fluid class="panel-change-password fill-height">
    <div class="pa-2 fill-height fill-width">
      <ChangePassword />
    </div>
  </v-container>
</template>
<script>
// import { authService } from "@/services";
import ChangePassword from "@/components/Common/ChangePassword";

export default {
  name: "panel-change-password",
  components: { ChangePassword }
};
</script>
<style lang="scss">
@import "ChangePassword";
</style>
